<div appFlexLayout="column">

  <div appFlex>
    <span appFlex="grow"></span>
    <button mat-icon-button (click)="addStandardUtm()"><i class="mdi mdi-briefcase-plus-outline"></i></button>
    <button mat-icon-button (click)="clearUtm()"><i class="mdi mdi-close-circle-outline"></i></button>
    <button [disabled]="!(this.utmFormArray.valid)" mat-raised-button class="mat-accent ml-16 white-text"
      (click)="saveWithUtms()">{{'Enregistrer'|translate}}</button>
  </div>

  <div appFlexLayout="row" *ngFor="let control of utmFormArray.controls; index as i" [formGroup]="control">

    <mat-form-field appFlex="50">
      <mat-label>{{ "Clé" | translate }}</mat-label>
      <input type="text" matInput formControlName="key" />
    </mat-form-field>

    <mat-form-field appFlex="50">
      <mat-label>{{ "Valeur" | translate }}</mat-label>
      <input type="text" matInput formControlName="value" />
    </mat-form-field>

    <button mat-icon-button (click)="removeUtm(i)"><i class="mdi mdi-delete-outline"></i></button>

  </div>

  <div appFlexLayout="row">
    <span appFlex="grow"></span>
    <button mat-icon-button (click)="addUtm()"><i class="mdi mdi-plus-circle-outline"></i></button>
  </div>


</div>